import { render, staticRenderFns } from "./SignRequestPage.vue?vue&type=template&id=82435d7a&"
import script from "./SignRequestPage.vue?vue&type=script&lang=js&"
export * from "./SignRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports